import { GripVertical } from "lucide-react";
import type React from "react";

interface ResizeHandleProps {
  onMouseDown: (event: React.MouseEvent) => void;
  isDragging: boolean;
  ariaLabel: string;
  /** Apply a subtle drop-shadow while dragging. Defaults to true. */
  shadow?: boolean;
}

export function ResizeHandle({ onMouseDown, isDragging, ariaLabel, shadow = true }: ResizeHandleProps) {
  const draggingClasses = `bg-blue-50 border-l-2 border-r-2 border-blue-300${shadow ? " shadow-lg" : ""}`;
  const restingClasses = "hover:bg-gray-100 border-l border-r border-gray-200";
  return (
    <div
      className={`flex items-center justify-center w-2.5 py-2 cursor-ew-resize transition-colors ${
        isDragging ? draggingClasses : restingClasses
      }`}
      onMouseDown={onMouseDown}
      role="separator"
      aria-label={ariaLabel}
    >
      <GripVertical className={`h-5 w-5 ${isDragging ? "text-blue-500" : "text-gray-400"}`} />
    </div>
  );
}
